import { gql } from "apollo-boost";

export const GET_RANK_LIB = gql`
  query($rankClassification: String) {
    allRankLib(rankClassification: $rankClassification) {
      edges {
        node {
          rankId
          rankCode
          rankName
          rankDesc
          rankClassification
          rankColor
          rankLogo
          updateDate
          updateSource
        }
      }
    }
  }
`;
